export const includeHistoryDetails = () => {
  return {
    type: "INCLUDE_HISTORY",

  }
}
export const removeFile = (id) => {
  return {
    type: "REMOVE_FILE",
    id
  }
}

export const addDropzoneFiles = (payload) => {
  return {
    type: "ADD_DROPZONE_FILES",
    payload
  }
}

export const updateReadyToImportFiles = (payload) => {
  return {
    type: "UPDATE_READYTOIMPORT_DATASET",
    payload
  }
}

export const clearDropzoneData = () => {
  return {
    type: "CLEAR_DROPZONE_DATA",
    
  }
}

export const clearAllDataRows = () => {
  return {
    type: "CLEAR_ALL"
  
  }
}

export const updateInProgressFiles = (payload) => {
  return {
    type: "CURRENT_STATE_LOADED_FILES_FINAL",
    payload
  
  }
}

export const updateImportedFileStatus = (payload) => {
  return {
    type: "IMPORTED_FILES_STATUS_UPDATE",
    payload
  
  }
}

export const updateHistoryData = (payload) => {
  return {
    type: "UPDATE_HISTORY_DATA",
    payload
  
  }
}